'use client';

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faSparkles } from '@fortawesome/pro-solid-svg-icons';
import type { ChatAvatarProps } from './types';

const VARIANT_DEFAULTS = {
  user: { icon: faUser, bgColor: 'bg-neutral-200', iconColor: 'text-neutral-500' },
  assistant: { icon: faSparkles, bgColor: 'bg-teal-100', iconColor: 'text-teal-600' },
} as const;

const ChatAvatar: React.FC<ChatAvatarProps> = ({
  variant,
  icon,
  bgColor,
  iconColor,
  className = '',
}) => {
  const defaults = VARIANT_DEFAULTS[variant];

  return (
    <div
      className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 mt-0.5 ${bgColor ?? defaults.bgColor} ${className}`}
      aria-hidden="true"
      data-testid={`chat-avatar-${variant}`}
    >
      <FontAwesomeIcon
        icon={icon ?? defaults.icon}
        className={`text-xs ${iconColor ?? defaults.iconColor}`}
      />
    </div>
  );
};

export default ChatAvatar;
